import { defineStore } from 'pinia'
import { userService } from "@/helpers/authservice/user.service";
import { useNotificationStore } from '@/store/pinia/index'


import router from '@/router'

const user = JSON.parse(localStorage.getItem('user'));


export const useAuthFakeStore = defineStore('authFake', {
    state: () => ({
        status: user ? { loggeduser: true } : {},
        user: user || null
    }),
    getters: {
        loggedIn() {
            return !!user
        },
    },
    actions: {
        login({ email, password }) {
            this.status = { loggingIn: true }
            this.user = email
            const notificationStore = useNotificationStore()
           userService.login(email, password).then(user => {
                this.user = user
               this.status = { loggeduser: true }
                router.push('/');

           }).catch(error => {
                this.status = {}
                this.user = null
                notificationStore.error(error)
            })

        },
        logout() {
            this.status = {}
            this.user = null
            localStorage.removeItem('user')
            router.push('/login');


        },
        registeruser(user) {
            this.status = { registering: true }
            const notificationStore = useNotificationStore()

            userService.register(user).then(() => {
                this.status = {}
                notificationStore.success('Registration successful')
                router.push('/login');
            }).catch(error => {
                this.status = {}
                notificationStore.error(error)
                console.error({ error })
            })
        }
    },
})